module.exports = __webpack_public_path__ + "img/icon-track-activity.bfd7553.svg";